class ApiCallStorageReaderInterface {
  register = (name, method, path, isExpiredFunc, updateIsExpiredFuncTracking, defaultValue, formatResultFunc) => {
    throw new Error("register method not implemented");
  };
  read = async (name, queryParam = {}) => {
    throw new Error("read method not implemented");
  };
  refresh = async (name, queryParam = {}) => {
    throw new Error("refresh method not implemented");
  };
}
export { ApiCallStorageReaderInterface };